import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./Pages/Home/HomePage";
import LoginPage from "./Pages/Auth/LoginPage";
import "react-international-phone/style.css";
import ActivatePage from "./Pages/Auth/ActivatePage";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/*" element={<HomePage />} />
          <Route exact path="/login" element={<LoginPage />} />
          {/* <Route exact path="/activate/:token" element={<ActivatePage />} /> */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
